<template>
  <div class="ListPanel">
    <HeaderSection 
      :title="title"
      :closeLinkTo="{ name: 'home' }">
      <p>
        Bij het filteren op thema’s kan er worden gezocht op een specifiek thema. Deze thema’s staan gegroepeerd per soort, hierdoor kan men makkelijker het gewenste thema vinden in de lijst.
      </p>
    </HeaderSection>

    <List 
      :items="items" 
      :sortingBy="sortingBy"
      :groupBy="groupBy"
      type="thema" 
      readmore="tonen" />

  </div>
</template>

<script>

import List from '@/components/lists/List';
import HeaderSection from '@/components/section/HeaderSection';

export default {
  name: 'ListThemas',
  components: {
    List,
    HeaderSection
  },
  data() {
    return {
      title: 'Thema\'s',
      sortingBy: [
        {
          key: 'name',
          label : 'A-Z',
          dir: 'ASC'
        }
      ],
      groupBy: [
        {
          key: 'category',
          label: 'Categorie',
          dir: 'ASC'
        }
      ]
    }
  },
  computed: {
    items() {
      let items = this.$store.getters.getThemaList;
      items.forEach((item) => {
        item.to = { name: 'thema-beknopt', params: { slug: item.slug } };
        return item;
      });

      return items;
    }
  },
  destroyed() {
    if (this.$store.map) {
      this.$store.map.setFilter('verhalen', ['all']);
      this.$store.map.setFilter('verhalen_muted', ['==', 'type', 'off']);
    }
  }
}
</script>

<style lang="scss">

  .ListPanel {
    height: 100%;
    display: flex;
    flex-direction: column;

    .List {
      width: 100%;
      flex-grow: 1;
    }
  }

</style>
